/**
 * Constantes de autenticação
 */

export const AUTH_CONSTANTS = {
  // JWT Configuration
  JWT_SECRET: import.meta.env.VITE_JWT_SECRET || 'your-super-secret-key-change-in-production',
  JWT_EXPIRATION: '24h',
  JWT_REFRESH_EXPIRATION: '7d',

  // Cookie Configuration
  COOKIE_NAME: 'accessToken',
  COOKIE_REFRESH_NAME: 'refresh_token',
  COOKIE_PATH: '/',
  COOKIE_SECURE: import.meta.env.MODE === 'production',
  COOKIE_HTTP_ONLY: true,
  COOKIE_SAME_SITE: 'lax' as const,

  // Session Configuration
  SESSION_EXPIRATION_MS: 24 * 60 * 60 * 1000, // 24 hours

  // Routes Configuration
  PUBLIC_ROUTES: ['/login', '/register', '/forgot-password', '/', '/landing'],
  PROTECTED_ROUTES: ['/dashboard', '/profile', '/settings'],
  ADMIN_ROUTES: ['/admin', '/users', '/analytics'],
  DOCTOR_ROUTES: ['/consultas', '/pacientes', '/agenda'],
  PATIENT_ROUTES: ['/minhas-consultas', '/meus-documentos', '/relatorios', '/perfil', '/prontuario'],
} as const;

// Role-based routes
export const ROLE_ROUTES = {
  ADMIN: ['/admin', '/users', '/analytics', '/dashboard'],
  DOCTOR: ['/consultas', '/pacientes', '/agenda', '/dashboard'],
  PATIENT: ['/minhas-consultas', '/meus-documentos', '/relatorios', '/dashboard', '/perfil', '/prontuario'],
} as const;

// Error messages
export const AUTH_ERRORS = {
  INVALID_CREDENTIALS: 'Email ou senha inválidos',
  USER_NOT_FOUND: 'Usuário não encontrado',
  EMAIL_ALREADY_EXISTS: 'Este email já está registrado',
  INVALID_TOKEN: 'Token inválido ou expirado',
  MISSING_TOKEN: 'Token de autenticação não fornecido',
  UNAUTHORIZED: 'Você não tem permissão para acessar este recurso',
  SERVER_ERROR: 'Erro do servidor. Tente novamente mais tarde',
} as const;

export const TOAST_MESSAGES = {
  LOGIN_SUCCESS: 'Bem-vindo! Você foi autenticado com sucesso.',
  LOGIN_ERROR: 'Erro ao fazer login. Verifique suas credenciais.',
  LOGOUT_SUCCESS: 'Você foi desconectado com sucesso.',
  REGISTER_SUCCESS: 'Conta criada com sucesso! Bem-vindo.',
  REGISTER_ERROR: 'Erro ao criar conta. Tente novamente.',
  SESSION_EXPIRED: 'Sua sessão expirou. Por favor, faça login novamente.',
} as const;
